export const COMPLAINTS_API_ERROR = "COMPLAINTS_API_ERROR";
export const COMPLAINTS_COMPLAINTS_LOADING = "COMPLAINTS_COMPLAINTS_LOADING";
export const COMPLAINTS_COMPLAINTS_LOADED = "COMPLAINTS_COMPLAINTS_LOADED";
export const COMPLAINTS_COMPLAINT_LOADING = "COMPLAINTS_COMPLAINT_LOADING";
export const COMPLAINTS_COMPLAINT_LOADED = "COMPLAINTS_COMPLAINT_LOADED";
export const COMPLAINTS_NEW_COMPLAINT_SUBMITTING = "COMPLAINTS_NEW_COMPLAINT_SUBMITTING";
export const COMPLAINTS_COMPLAINT_UPDATING = "COMPLAINTS_COMPLAINT_UPDATING";
export const COMPLAINTS_COMPLAINT_ACTIVITES_LOADING = "COMPLAINTS_COMPLAINT_ACTIVITES_LOADING";
export const COMPLAINTS_COMPLAINT_ACTIVITES_LOADED = "COMPLAINTS_COMPLAINT_ACTIVITES_LOADED";
export const COMPLAINTS_NEW_COMPLAINT_ACTIVITY_SUBMITTING = "COMPLAINTS_NEW_COMPLAINT_ACTIVITY_SUBMITTING";
export const COMPLAINTS_NEW_COMPLAINT_ACTIVITY_COMMS_SUBMITTING = "COMPLAINTS_NEW_COMPLAINT_ACTIVITY_COMMS_SUBMITTING";
export const COMPLAINTS_COMPLAINT_ACTIVITES_FLAGGING = "COMPLAINTS_COMPLAINT_ACTIVITES_FLAGGING";
export const COMPLAINTS_COMPLAINT_ACTIVITES_FLAGGED_COMPLETE = "COMPLAINTS_COMPLAINT_ACTIVITES_FLAGGED_COMPLETE";
export const COMPLAINTS_NEW_COMPLAINT_ACTIVITY_DOCUMENT_SUBMITTING = "COMPLAINTS_NEW_COMPLAINT_ACTIVITY_DOCUMENT_SUBMITTING";
export const COMPLAINTS_NEW_COMPLAINT_ACTIVITY_TRANSFER_SUBMITTING = "COMPLAINTS_NEW_COMPLAINT_ACTIVITY_TRANSFER_SUBMITTING";
export const COMPLAINTS_NEW_COMPLAINT_ACTIVITY_TRANSFER_SUBMITTED = "COMPLAINTS_NEW_COMPLAINT_ACTIVITY_TRANSFER_SUBMITTED";
export const COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_LEAD_SUBMITTING = "COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_LEAD_SUBMITTING";
export const COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_ASSIGN_SUBMITTING = "COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_ASSIGN_SUBMITTING";
export const COMPLAINTS_NEW_COMPLAINT_ACTIVITY_ATTACH_EMAIL_SUBMITTING = "COMPLAINTS_NEW_COMPLAINT_ACTIVITY_ATTACH_EMAIL_SUBMITTING";
export const COMPLAINTS_COMPLAINT_ROLES_LOADING = "COMPLAINTS_COMPLAINT_ROLES_LOADING";
export const COMPLAINTS_COMPLAINT_ROLES_LOADED = "COMPLAINTS_COMPLAINT_ROLES_LOADED";
export const COMPLAINTS_COMPLAINT_USER_ROLES_LOADING = "COMPLAINTS_COMPLAINT_USER_ROLES_LOADING";
export const COMPLAINTS_COMPLAINT_USER_ROLES_LOADED = "COMPLAINTS_COMPLAINT_USER_ROLES_LOADED";
export const COMPLAINTS_CASE_ROLE_SUBMITTING = "COMPLAINTS_CASE_ROLE_SUBMITTING";
export const COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_CLOSE_SUBMITTING = "COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_CLOSE_SUBMITTING";
export const COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_REOPEN_SUBMITTING = "COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_REOPEN_SUBMITTING";
export const COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_CLONE_SUBMITTING = "COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_CLONE_SUBMITTING";
export const COMPLAINTS_STORE_SEARCH = "COMPLAINTS_STORE_SEARCH";
export const COMPLAINTS_CASE_ROLE_DELETING = "COMPLAINTS_CASE_ROLE_DELETING";
export const COMPLAINTS_CASE_ROLE_DELETED = "COMPLAINTS_CASE_ROLE_DELETED";
export const COMPLAINTS_ACTIVITY_EDIT = "COMPLAINTS_ACTIVITY_EDIT";
export const COMPLAINTS_ANALYTICS_LOADING = "COMPLAINTS_ANALYTICS_LOADING";
export const COMPLAINTS_ANALYTICS_LOADED = "COMPLAINTS_ANALYTICS_LOADED";
export const COMPLAINTS_TEAM_ANALYTICS_LOADING = "COMPLAINTS_TEAM_ANALYTICS_LOADING";
export const COMPLAINTS_TEAM_ANALYTICS_LOADED = "COMPLAINTS_TEAM_ANALYTICS_LOADED";
export const COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_SLA_SUBMITTING = "COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_SLA_SUBMITTING";
export const COMPLAINTS_NEW_COMPLAINT_ACTIVITY_INTERNAL_MESSAGE_SUBMITTING = "COMPLAINTS_NEW_COMPLAINT_ACTIVITY_INTERNAL_MESSAGE_SUBMITTING";
export const loadComplaints = (params) => {
    return {
        type: COMPLAINTS_COMPLAINTS_LOADING,
        payload: params,
    };
};
export const loadComplaint = (caseId) => ({
    type: COMPLAINTS_COMPLAINT_LOADING,
    payload: { caseId },
});
export const submitComplaint = (payload) => ({
    type: COMPLAINTS_NEW_COMPLAINT_SUBMITTING,
    payload,
});
export const updateComplaint = (id, patchDocument, resourceTagsIds) => ({
    type: COMPLAINTS_COMPLAINT_UPDATING,
    payload: { id, patchDocument, resourceTagsIds },
});
export const loadActivities = (caseId, requestState) => ({
    type: COMPLAINTS_COMPLAINT_ACTIVITES_LOADING,
    payload: { caseId, requestState },
});
export const submitActivity = (id, model) => ({
    type: COMPLAINTS_NEW_COMPLAINT_ACTIVITY_SUBMITTING,
    payload: { id, model },
});
export const submitComms = (id, model) => ({
    type: COMPLAINTS_NEW_COMPLAINT_ACTIVITY_COMMS_SUBMITTING,
    payload: { id, model },
});
export const toggleActivityFlag = (caseId, id) => ({
    type: COMPLAINTS_COMPLAINT_ACTIVITES_FLAGGING,
    payload: { caseId, id },
});
export const submitActivityDocument = (id, model) => ({
    type: COMPLAINTS_NEW_COMPLAINT_ACTIVITY_DOCUMENT_SUBMITTING,
    payload: { id, model },
});
export const submitActivityTransfer = (id, model) => ({
    type: COMPLAINTS_NEW_COMPLAINT_ACTIVITY_TRANSFER_SUBMITTING,
    payload: { id, model },
});
export const submitAssignCaseLead = (id, model) => ({
    type: COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_LEAD_SUBMITTING,
    payload: { id, model },
});
export const submitAssignCase = (id, model) => ({
    type: COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_ASSIGN_SUBMITTING,
    payload: { id, model },
});
export const submitCloseCase = (id, model) => ({
    type: COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_CLOSE_SUBMITTING,
    payload: { id, model },
});
export const submitReopenCase = (id, model) => ({
    type: COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_REOPEN_SUBMITTING,
    payload: { id, model },
});
export const submitCloneCase = (id, model) => ({
    type: COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_CLONE_SUBMITTING,
    payload: { id, model },
});
export const submitAttachEmail = (id, mailId) => ({
    type: COMPLAINTS_NEW_COMPLAINT_ACTIVITY_ATTACH_EMAIL_SUBMITTING,
    payload: { id, mailId },
});
export const loadRoles = (caseId) => ({
    type: COMPLAINTS_COMPLAINT_ROLES_LOADING,
    payload: { caseId },
});
export const loadUserRoles = () => ({
    type: COMPLAINTS_COMPLAINT_USER_ROLES_LOADING,
    payload: {},
});
export const submitRole = (caseId, model) => ({
    type: COMPLAINTS_CASE_ROLE_SUBMITTING,
    payload: { caseId, model },
});
export const removeRole = (caseId, caseRoleId) => ({
    type: COMPLAINTS_CASE_ROLE_DELETING,
    payload: { caseId, caseRoleId },
});
export const submitActivityEdit = (caseId, reason, note, meta) => ({
    type: COMPLAINTS_ACTIVITY_EDIT,
    payload: { caseId, reason, note, meta },
});
export const loadAnalytics = (params) => {
    return {
        type: COMPLAINTS_ANALYTICS_LOADING,
        payload: { params },
    };
};
export const loadTeamAnalytics = () => {
    return {
        type: COMPLAINTS_TEAM_ANALYTICS_LOADING,
    };
};
export const submitOverrideCaseSla = (id, model, isPaused) => ({
    type: COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_SLA_SUBMITTING,
    payload: { id, model, isPaused },
});
export const submitInternalMessage = (id, model) => ({
    type: COMPLAINTS_NEW_COMPLAINT_ACTIVITY_INTERNAL_MESSAGE_SUBMITTING,
    payload: { id, model },
});
